<div class="confirm">
  <div class="title">{{ data.title }}</div>
  <div class="message" [innerHTML]="data.message"></div>
  <button matRipple class="button primary-button yes" (click)="dialogRef.close(true)">{{ data.yes || 'Yes' }}</button>
  <button matRipple class="no" (click)="dialogRef.close(false)">{{ data.no || 'No' }}</button>
</div>
